import { createSlice } from "@reduxjs/toolkit";

export const eventSlice = createSlice({
  name: "events",
  initialState: {
    list: []
  } as any,
  reducers: {
    setEvents: (state, action) => {
      state.list = action.payload;
      
    },
    seeEvents: (state, action) => {
      // mark state.list seen where action.payload

      const newList = [...state.list];
      action.payload.forEach((eventId:string) => {
        const item = newList.find((i) => i.id === eventId);
        if (item) {
          item.seen = true;
        }
      });
      state.list = newList;
      
    },
    // (add events / update events)
  },
});

export const { setEvents, seeEvents } = eventSlice.actions;

export default eventSlice.reducer;
